import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {getChannelIconName} from '../../../helpers/channelViewHelpers';
import {ChannelModel} from '../../../models/api/channelModel';

/*
 * Props.
 */

interface DropdownItemChannelIconProps {
  channel: ChannelModel;
}

/*
 * Style.
 */

const StyledIconDiv = styled.div`
  grid-area: left-icon;
  padding: 2px;
  margin-right: 8px;
`;

/*
 * Component.
 */

export const DropdownItemChannelIcon: FC<DropdownItemChannelIconProps> = ({channel}) => {
  const theme = useUserTheme();
  const iconName = getChannelIconName(channel.contactSource);

  // TODO: Add accessible label.
  return (
    <StyledIconDiv>
      <Icon name={iconName} color={theme.greys.shade50} />
    </StyledIconDiv>
  );
};
